import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Button } from 'reactstrap'
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

import ModalRadioPharmacy from './ModalRadioPharmacy';



const TableRadioPharmacyActions = ({ data, state }) => {
    const history = useHistory();

    const [updateRadioPharmacy, setUpdateRadioPharmacy] = React.useState(false);
    
    const showRadioPharmacy = () => {
        /*
        let _url = "/radio-pharmacy/dashboard";

        history.push({
            pathname: _url,
            state: data.original
        });
        */
    }
    const updateRadioPharmacyModal = () => {
        setUpdateRadioPharmacy(true);
    }

    const closeRadioPharmacyModal = () => {
        setUpdateRadioPharmacy(false);
    }

    useEffect(() => {
        
    }, []);

    return (<Fragment>
        <td role="cell">
            <IconButton  onClick={updateRadioPharmacyModal}>
                <FontAwesomeIcon style={{fontSize: '15px' }} icon={faEye} />
            </IconButton>
        </td>
        <ModalRadioPharmacy
            opened={updateRadioPharmacy}
            updateRadioPharmacyModal={updateRadioPharmacyModal}
            closeRadioPharmacyModal={closeRadioPharmacyModal}
            radiofarmacia={data.original}
        />
    </Fragment>)
}

export default reduxForm({
    form: `modal-form`, // a unique identifier for this form
})(withTranslation('common')(TableRadioPharmacyActions));